export const DISPLAY_VALUE_TYPES = [
  { name: '전체', val: 'all' },
  { name: '평균', val: 'average' },
  { name: '최고', val: 'highest' },
  { name: '최저', val: 'lowest' },
];

export const DISPLAY_TIME_TYPES = [
  { name: '전체', val: 'all' },
  { name: '오전', val: 'am' },
  { name: '오후', val: 'pm' },
];